import { IntegrationType } from '@app/utils/consts';
import { apiInstance } from './api';
import { ApiRoutes } from './consts';
import axios from 'axios';
import { ApiBaseRoute } from './consts';

export const getIntegrations = async () => {
  return apiInstance.get(`${ApiRoutes.Business}${ApiRoutes.Integrations}/all`);
};

export const getBusinessIntegrations = async (businessId: string) => {
  // Use direct axios call to avoid interceptor conflicts
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${ApiBaseRoute}${ApiRoutes.Business}${ApiRoutes.Integrations}/all`, {
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'ECHO-Business-ID': businessId,
    },
  });
  
  return response;
};

export const getIntegration = async (type: string, accessToken?: string, businessId?: string) => {
  return apiInstance.get(
    `${ApiRoutes.Business}${ApiRoutes.Integrations}/connection/${type}`,
    accessToken ? {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ...(businessId ? { 'ECHO-Business-ID': businessId } : {}),
      },
    } : undefined
  );
};

export const createIntegration = async (data: {
  type: IntegrationType;
  connectionId?: string;
}) => {
  return apiInstance.post(
    `${ApiRoutes.Business}${ApiRoutes.Integrations}`,
    data
  );
};

export const deleteIntegration = async (id: string) => {
  return apiInstance.delete(
    `${ApiRoutes.Business}${ApiRoutes.Integrations}/${id}`
  );
};

export const updateIntegration = async (
  id: string,
  data: {
    connectionId?: string;
  }
) => {
  return apiInstance.patch(
    `${ApiRoutes.Business}${ApiRoutes.Integrations}/${id}`,
    data
  );
};

export const getConnectGoogleUrl = async () => {
  return apiInstance.get(`${ApiRoutes.Business}${ApiRoutes.Integrations}/google/connect-url`);
};
